import React from 'react';
import {data} from 'react-router';
import Blog from '../pages/Blog';
import {getBlogContent} from '../server/content.server';
export async function loader({request, params}) {
    const content = await getBlogContent(request.url, params);
    return data(content, {headers: {'Cache-Control': 'no-store'}});
}

export function headers({errorHeaders}) {
    const headers = new Headers(errorHeaders);
    headers.set('Cache-Control', 'no-store');
    return headers;
}
export default function BlogRoute({loaderData}) {
    return <Blog content={loaderData} />;
}
